export function fixarUrlDoAparelho(): void {
  const salvar = window.pdvDesktop?.salvarUrlTotem;
  if (!salvar) return;

  void salvar(window.location.origin);
}

export async function soltarUrlDoAparelho(): Promise<void> {
  const limpar = window.pdvDesktop?.limparUrlTotem

  if (!limpar) return

  try {
    await limpar()
  } catch {
    /* sem o Electron o caminho web ainda funciona */
  }
}
